import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { useAuth } from './AuthContext';

const ProjectContext = createContext(null);

export function ProjectProvider({ children }) {
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [currentProject, setCurrentProject] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get('/projects');
      setProjects(data);
      const savedId = parseInt(localStorage.getItem('dpots_project_id'));
      const found = data.find((p) => p.id === savedId) || data[0];
      if (found) {
        setCurrentProject(found);
        localStorage.setItem('dpots_project_id', String(found.id));
      }
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const switchProject = (p) => {
    setCurrentProject(p);
    localStorage.setItem('dpots_project_id', String(p.id));
  };

  return (
    <ProjectContext.Provider value={{ projects, currentProject, setCurrentProject: switchProject, loading, refresh }}>
      {children}
    </ProjectContext.Provider>
  );
}

export const useProject = () => useContext(ProjectContext);
